<template>
  <el-main class="userwrap">
    <div class="mybread">
      <p><i class="el-icon-location"></i>当前位置：</p>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>店铺管理</el-breadcrumb-item>
        <el-breadcrumb-item>店铺信息</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="form">
      <el-form ref="form" :model="form" label-width="120px" label-position="left">
        <el-form-item label="" style="margin-left: -120px;">
          <el-col :span="4">
            <el-select v-model="form.atype" placeholder="请选择类别" style="margin-right: 0; width: 100%;">
              <el-option label="店铺名" value="name"></el-option>
              <el-option label="地区" value="address"></el-option>
            </el-select>
          </el-col>
          <el-col :span="10" style="margin-right: 10px;">
            <el-input placeholder="请输入内容" v-model="form.key" clearable>
            </el-input>
          </el-col>
          <el-col :span="2">
            <el-button type="primary" icon="el-icon-search" @click="search" @keyup.enter.native="search">搜索</el-button>
          </el-col>
        </el-form-item>
        <el-form-item label="打卡时间" prop="time">
          <el-col :span="12">
            <el-date-picker v-model="form.time" type="datetimerange" range-separator="--" start-placeholder="开始日期"
              end-placeholder="结束日期" style="margin-right: 10px;" @change="search(false)">
            </el-date-picker>
          </el-col>
        </el-form-item>

        <el-form-item label="已选条件：">
          <el-tag v-for="tag in tags" :key="tag.key" color="#003153" effect="dark" closable @close="removeTag(tag)">
            {{ tag.key }}: {{ tag.value }}
          </el-tag>
        </el-form-item>

      </el-form>
    </div>

    <div class="table">
      <div class="filterwrap">
        <div class="filter">
          <el-checkbox-group class="filtergroup" v-model="checkList" prop="checkList" :min="1">
            <el-checkbox label="店铺名"></el-checkbox>
            <el-checkbox label="店铺编号"></el-checkbox>
            <el-checkbox label="店铺验证码"></el-checkbox>
            <el-checkbox label="门店地址"></el-checkbox>
            <el-checkbox label="店铺二维码"></el-checkbox>
            <el-checkbox label="氧疗完成人次"></el-checkbox>
          </el-checkbox-group>
        </div>
        <div class="btnarea">
          <el-button icon="el-icon-plus" @click="addFn">新增</el-button>
          <el-button  @click="creatFn">批量生成二维码</el-button>
        </div>
      </div>
      <el-table :data="tableData" border stripe style="width: 100%;" highlight-current-row>
        <el-table-column prop="name" label="店铺名" header-align="center" align="center" min-width="80" v-if="check('店铺名')">
          <template slot-scope="scope">
            {{ scope.row.name ? scope.row.name : '暂无'}}
          </template>
        </el-table-column>
        <el-table-column prop="store_code" label="店铺编号" header-align="center" align="center" min-width="60" v-if="check('店铺编号')"></el-table-column>
        <el-table-column prop="verify_code" label="店铺验证码" header-align="center" align="center" min-width="100" v-if="check('店铺验证码')">
          <template slot-scope="scope">
            {{ scope.row.verify_code ? scope.row.verify_code : '暂无'}}
          </template>
        </el-table-column>
        <el-table-column prop="address" label="门店地址" header-align="center" align="center" min-width="100" v-if="check('门店地址')">
          <template slot-scope="scope">
            {{ scope.row.province ? `${scope.row.province} ${scope.row.city} ${scope.row.area} ${scope.row.address}` : '暂无'}}
          </template>
        </el-table-column>
        <el-table-column prop="qrcode" label="店铺二维码" header-align="center" align="center" min-width="60" v-if="check('店铺二维码')">
          <template slot-scope="scope">
            <el-image style="width: 100px; height: 100px" :src="scope.row.httpFile" fit="cover" :preview-src-list="[scope.row.httpFile]">
              <div slot="error" class="el-image__error">暂无数据</div>
            </el-image>
          </template>
        </el-table-column>
        <el-table-column prop="sign_user_count" label="氧疗完成人次" header-align="center" align="center" min-width="60" v-if="check('氧疗完成人次')"/>
        <el-table-column prop="city" label="操作" header-align="center" align="center" min-width="80" fixed="right">
          <template slot-scope="scope">
            <span class="link" style="cursor: pointer;" @click="handleDelete(scope.row)">删除</span>
            <span style="margin: 0 10px;">|</span>
            <span class="link" style="cursor: pointer;" @click="handleClick(scope.row)">编辑</span>
          </template>
        </el-table-column>
      </el-table>
      <div class="apage">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="1"
          :page-size="30" layout="total, prev, pager, next, jumper" :total="total">
        </el-pagination>
      </div>
    </div>
  </el-main>
</template>


<script>
import * as api from '@/api'
export default {
  name: 'Shop',
  data() {
    return {
      checkList: [
        '店铺名',
        '店铺编号',
        '店铺验证码',
        '门店地址',
        '店铺二维码',
        '氧疗完成人次',
      ],
      form: {
        key: '',
        atype: 'name',
        time: ['', ''],
      },
      tableData: [],
      perPage: 30,
      p: 1,
      total: 30,
    }
  },
  computed: {
    tags() {
      let temp = [
        {
          key: this.dd.shopType[this.form.atype],
          val: 'atype',
          value: this.form.key,
          active: !!this.form.atype && !!this.form.key,
        },
        {
          key: '打卡时间',
          val: 'time',
          value: this.dateValue(this.form.time),
          active: !!this.form.time && this.form.time[0] && !!this.form.time && this.form.time[1],
        },
      ]
      temp = temp.filter((item) => item.active)
      return temp
    },
  },
  mounted() {
    this.getShopList()
  },
  methods: {
    dateValue(dateArr) {
      if (Array.isArray(dateArr)) {
        return this.fdate(dateArr[0]) + '-' + this.fdate(dateArr[1])
      } else {
        return ''
      }
    },
    check(key) {
      return this.checkList.includes(key)
    },
    removeTag(tag) {
      if (tag.val === 'time') {
        this.form.time = ['', '']
      }
      !{
        type: () => {
          this.form['key'] = undefined
        },
      }[tag.val]?.()
      this.form[tag.val] = ''
      this.form.key = this.form.atype == '' ? '' : this.form.key
      this.getShopList()
    },
    search() {
      this.p = 1
      this.getShopList()
    },
    getShopList() {
      const time = this.form.time || []
      const postData = {
        ...this.form,
        p: this.p,
        per_page: this.perPage,
        start_date: this.fdate(time[0]),
        end_date: this.fdate(time[1]),
        [this.form.atype]: this.form.key,//搜索
      }
      api.getShopList(postData).then((res) => {
        this.tableData = res.resData.itemList
        this.total = Number(res.resData.totalNum)
      })
    },
    handleDelete(item) {
      this.$confirm('此操作将删除该店铺, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          api.updateShopInfo({ del_str: item.id }).then(() => {
            this.$message({
              type: 'success',
              message: '删除成功!',
            })
            this.getShopList()
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除',
          })
        })
    },
    handleCurrentChange(p) {
      this.p = p
      this.getShopList()
    },
    handleClick(row) {
      // console.log(row)
      this.$router.push(`/shop/detail?id=${row.id}`)
    },
    addFn() {
      this.$router.push(`/shop/detail`)
    },
    handleSizeChange() {
      // console.log('sizechange')
    },
    onSubmit() {
      // console.log('submit!')
    },
    creatFn() {
      const postData = {}
      api.createShopsCode(postData).then(() => {
        this.$message({
          type: 'success',
          message: '操作成功!',
        })
        this.getShopList()
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.link {
  color: $c;
}

.userwrap {
  .filterwrap {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    padding: 0 0 20px 0;

    .filter {
      width: 85%;
    }

    .btnarea {
      box-sizing: border-box;
      width: 15%;
      padding: 0 20px;
      display: flex;
      justify-content: flex-end;
    }
  }

.el-checkbox-group.filtergroup .el-checkbox {
  width: auto;
}

.apage {
  background: #f2f2f2;
  padding: 8px;
  text-align: right;
}

.el-select {
  margin-right: 20px;
}

.el-tag {
  margin-right: 10px;
  margin-bottom: 10px;
  height: 36px;
  line-height: 36px;
  border: none;
}

.form {
  @extend %box;
  padding: 30px;
  margin-bottom: 20px;
}

.table {
  @extend %box;
  padding: 30px;
}

.line {
  text-align: center;
}
}
</style>